export default "__VITE_ASSET__BqpVTfER__"